<template>
  <div v-if="series && series.length" class="card my-2">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-lg-12">
          <div class="cui__utils__heading mb-0">
            <strong>Total number of Messages Per channel</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" style="text-align: center">
      <apex-chart
        v-if="!$parent.loading"
        type="donut"
        width="90%"
        :options="chartOptions"
        :series="series"
      ></apex-chart>
      <a-skeleton active v-else />
    </div>
  </div>
</template>

<script>
import common from '@/utils/analytics/common'
import apexChart from 'vue-apexcharts'
import { Skeleton } from 'vue-loading-skeleton'
export default {
  name: 'total-messages',
  components: {
    apexChart,
    ASkeleton: Skeleton
  },
  props: {
    totalData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      series: [],
      chartOptions: {
        legend: {
          position: 'bottom'
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                style: {
                  fontSize: '13px'
                },
                value: {
                  offsetY: -1,
                  show: true
                  // formatter: function (val) {
                  //     console.log(val, ' formatter')
                  //     return val
                  // }
                },
                total: {
                  show: true,
                  label: 'Total Messages',
                  color: '#000',
                  fontSize: '13px',
                  formatter: function (w) {
                    let total = w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0)
                    return common.numberWithCommas(total)
                  }
                }
              }
            }
          }
        },
        labels: [],
        chart: {
          type: 'donut'
        }
      }
    }
  },
  mounted() {},
  watch: {
    totalData: {
      deep: true,
      immediate: true,
      handler() {
        this.series = this.totalData.map((t) => parseFloat(t.value, 10))
        this.chartOptions = {
          ...this.chartOptions,
          labels: this.totalData.map((t) =>
            common.handleChannelName(t.name).toUpperCase()
          ),
          colors: this.totalData.map(
            (c) =>
              common.getSocialIcon(c.slug.toLowerCase()).colorHexa || '#ff1744'
          )
        }
      }
    }
  }
}
</script>

<style scoped>
.no-data-placeholder {
  margin-top: 30px;
}
@media (max-width: 1400px) {
  .apexcharts-datalabel-label {
    font-size: 11px !important;
  }
}
</style>
<style lang="scss">
.no-data-placeholder {
  .v-progress-circular__info {
    width: 100%;
    span {
      display: block;
      font-size: 16px;
      color: #000;
    }
  }
}
</style>
<style src="@/assets/css/bs-helpers.css" lang="css" scoped/>
